import classnames from 'classnames';
import CheckFilled from '~/icons/CheckFilled';
import {
  CardWrapper,
  ImageWrapper,
  InnerWrapper,
  ListItem
} from './HightlightCard.styles';
import { FeatureTourHighlightCards } from '../constants';
import { FeatureTourHighlightInfo } from '../useGetFeatureTourHighlights';

const HighlightCard = ({
  cardType,
  title,
  subtitle,
  imgProps,
  listItems,
  callToAction: CallToAction
}: FeatureTourHighlightInfo) => {
  const isNoAccidentCard = cardType === FeatureTourHighlightCards.NoAccident;

  return (
    <CardWrapper>
      <InnerWrapper
        className={classnames({
          'm:gap-16': isNoAccidentCard
        })}
      >
        {imgProps && (
          <ImageWrapper>
            <img className="h-24" src={imgProps.src} alt={imgProps.alt} />
          </ImageWrapper>
        )}
        <span className="text-blue-6 tl-header-m">{title}</span>
        {subtitle && <span className="text-grey-5 tl-body-m">{subtitle}</span>}
        {listItems && (
          <ul className="flex flex-col gap-8">
            {listItems.map(item => (
              <ListItem key={item}>
                <CheckFilled className="mt-4 h-16 w-16 flex-none text-green-2" />
                {item}
              </ListItem>
            ))}
          </ul>
        )}
        {CallToAction && <CallToAction />}
      </InnerWrapper>
    </CardWrapper>
  );
};

export default HighlightCard;
